import { c as _c } from "react/compiler-runtime";
import { IconDotsVertical, IconPlus } from "@tabler/icons-react";
import { Favicon } from "@/components/icons/favicon";
import { EXTERNAL_TOOLS, REPOSITORY_SLUG } from "@domainstack/constants";
import { Button } from "@domainstack/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@domainstack/ui/dropdown-menu";
import { ScrollArea } from "@domainstack/ui/scroll-area";
import { Tooltip, TooltipContent, TooltipTrigger } from "@domainstack/ui/tooltip";
import { cn } from "@domainstack/ui/utils";
type ToolsDropdownProps = {
  domain: string;
  enabled?: boolean;
};
export function ToolsDropdown(t0) {
  const $ = _c(21);
  const {
    domain,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const t2 = !enabled && "cursor-not-allowed";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("pointer-events-auto", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = !enabled;
  let t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconDotsVertical />;
    t6 = <span className="sr-only">Open tools menu</span>;
    $[2] = t5;
    $[3] = t6;
  } else {
    t5 = $[2];
    t6 = $[3];
  }
  let t7;
  if ($[4] !== t4) {
    t7 = <Button variant="outline" size="icon" aria-label="Open menu" disabled={t4}>{t5}{t6}</Button>;
    $[4] = t4;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t3 || $[7] !== t7) {
    t8 = <DropdownMenuTrigger nativeButton={false} render={<TooltipTrigger render={<div className={t3}>{t7}</div>} />} />;
    $[6] = t3;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <TooltipContent>Third-party tools</TooltipContent>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t8) {
    t10 = <Tooltip>{t8}{t9}</Tooltip>;
    $[10] = t8;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== domain) {
    t11 = EXTERNAL_TOOLS.map(tool => <DropdownMenuItem key={tool.name} closeOnClick={false} nativeButton={false} render={<a href={tool.buildUrl(domain)} target="_blank" rel="noopener noreferrer"><Favicon domain={tool.faviconDomain} />{tool.name}</a>} />);
    $[12] = domain;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <DropdownMenuSeparator />;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <DropdownMenuItem closeOnClick={false} nativeButton={false} render={<a href={`https://github.com/${REPOSITORY_SLUG}/issues/new`} onClick={_temp} target="_blank" rel="noopener"><IconPlus />Suggest a tool</a>} />;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t11) {
    t14 = <DropdownMenuContent align="end" className="flex min-w-52 flex-col overflow-hidden p-0"><ScrollArea className="max-h-[65vh] min-h-0 flex-1"><div className="p-1">{t11}{t12}{t13}</div></ScrollArea></DropdownMenuContent>;
    $[16] = t11;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t10 || $[19] !== t14) {
    t15 = <DropdownMenu>{t10}{t14}</DropdownMenu>;
    $[18] = t10;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  return t15;
}
function _temp(e) {
  e.preventDefault();
  const url = new URL(`https://github.com/${REPOSITORY_SLUG}/issues/new`);
  url.searchParams.set("labels", "suggestion");
  url.searchParams.set("title", "Add [TOOL] to tools dropdown");
  url.searchParams.set("body", "I suggest adding the following tool to the tools dropdown:\n\n[Add the name, URL, and a brief description of the tool here]");
  window.open(url.toString(), "_blank", "noopener");
}